import { Tab } from '@quickbit/backoffice-core-frontend';
import { AccountingSettlement } from './AccountingSettlement';
import { ApiKey } from './ApiKey';
import { BrandingPage } from './Branding';
import { ConfigPage } from './Config';
import { Kyb } from './Kyb';
import { Orders } from './Orders';
import { Wallet } from './Wallet';
import { Recipients } from './Wallet/tabs';

export const tabKyb: Tab = {
  component: <Kyb />,
  icon: 'error',
  name: 'Know Your Business',
  requiredPermissions: ['view_accounting'],
};

export const tabsData: Tab[] = [
  {
    component: <AccountingSettlement />,
    icon: 'document',
    name: 'Accounting',
    requiredPermissions: ['view_accounting'],
  },
  {
    component: <Orders />,
    icon: 'list',
    name: 'Orders',
    requiredPermissions: ['view_orders'],
  },
  {
    component: <Wallet />,
    icon: 'wallet',
    name: 'Wallet',
    requiredPermissions: ['view_corporate_wallet'],
    subTabs: [
      {
        component: <Wallet />,
        icon: 'send',
        name: 'Send',
        requiredPermissions: ['view_corporate_wallet'],
      },
      {
        component: <Recipients />,
        icon: 'community',
        name: 'Recipients',
        requiredPermissions: ['view_corporate_wallet'],
      },
    ],
  },
  {
    component: <ConfigPage />,
    icon: 'filter',
    name: 'Config',
    requiredPermissions: ['view_orders'], // TODO: change to new permission
    subTabs: [
      {
        component: <ConfigPage />,
        icon: 'filter',
        name: 'Configure',
        requiredPermissions: ['view_permissions'],
      },
      {
        component: <ApiKey />,
        icon: 'lock',
        name: 'Api key',
        requiredPermissions: ['view_orders'],
      },
    ],
  },
  {
    component: <BrandingPage />,
    icon: 'filter',
    name: 'Branding',
    requiredPermissions: ['view_config', 'edit_config'],
  },
];
